import purify from "dompurify"
import { get } from "shared/lib/api"
import { Spinner } from "spin.umd.js"

export default function fetchUserFeedbackInfoSections(opts = {}) {
  const targetEl = document.getElementById(opts.targetId)
  if (!targetEl) return

  const path = opts.path
  const sections = opts.sections
  const spinner = new Spinner({
    length: 6,
    width: 4,
    radius: 20,
    corners: 0,
    top: "3em",
  })

  targetEl.style.position = "relative"
  targetEl.appendChild(spinner.spin().el)

  sections.forEach(section => {
    get(`${path}.js?section=${section}`)
      .then(resp => {
        spinner.stop()
        // since the sections are fetched async, this makes sure they'll stick to the
        // order in html
        const el = targetEl.querySelector(`.${section}`)
        el.insertAdjacentHTML("beforeend", purify.sanitize(resp.data))
        ReactRailsUJS.mountComponents(el)
      })
      .catch(() => {
        spinner.stop()
        window.appendFlash(
          "Couldn't load all data. Please try again later.",
          "danger"
        )
      })
  })
}
